import api from "../services/Api";
import { infoUser, login } from "../services/auth";
import { logout as exit } from "../services/auth";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import React, { createContext, useEffect, useState } from "react";
import jwt from "jsonwebtoken";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

const API_OPCOES_MENU = "/opcoesmenu/index";
const API_SHOW_PERFIL = "/perfil/show/";

export const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const {
    nome_usuario,
    id_tipo_usuario,
    app_logo,
    app_nome,
    preposto,
    link_whatsapp,
    id_emite_mtr,
    id_tipo_contrapartida,
    id_local,
    id_preposto,
    IdDepartamento,
  } = infoUser();
  const [idPreposto, setIdPreposto] = useState(id_preposto);
  const [idTipoUsuario, setIdTipoUsuario] = useState(id_tipo_usuario);
  const [appNome, setAppNome] = useState(app_nome);
  const [appLogo, setAppLogo] = useState(app_logo);
  const [idEmiteMtr, setIdEmiteMtr] = useState(id_emite_mtr);
  const [idTipoContrapartida, setIdTipoContrapartida] = useState(
    id_tipo_contrapartida
  );
  const [versaoApp, setVersaoApp] = useState(process.env.REACT_APP_VERSION);
  const [timerUpdate, setTimeUpdate] = useState(180000); //Timer do atualizador de versão
  const [idLocal, setIdLocal] = useState(id_local);
  const [idDepartamento, setIdDepartamento] = useState(IdDepartamento);
  const [idTipoMenu, setIdTipoMenu] = useState("");
  const [atualizarVersao, setAtualizarVersao] = useState(false);

  //Variavel para tratamento de erros de request
  const [erro, setErro] = useState(false);
  const [resetSenha, setResetSenha] = useState(false);

  async function getOpcoesMenu() {
    await api
      .get(API_OPCOES_MENU)
      .then((res) => {
        localStorage.setItem("menu", JSON.stringify(res.data));
      })
      .catch((error) => console.log(error));
  }

  async function getPerfil(id) {
    const response = await api.get(API_SHOW_PERFIL + id);
    localStorage.setItem("tipoMenu", response.data.data.IdTipoMenu);
    setIdTipoMenu(response.data.data.IdTipoMenu);
  }

  // Verifica versao
  // async function appVersao() {
  //   const response = await api.get("/getversao");
  //   var versaoDatabase = response.data.Valor;
  //   versaoDatabase = versaoDatabase.replace(/[^0-9]/g, "").trim();
  //   var versaoApp = process.env.REACT_APP_VERSION;
  //   versaoApp = versaoApp.replace(/[^0-9]/g, "").trim();

  //   console.log(`versao databse ${versaoDatabase}`);
  //   console.log(`versao app ${versaoApp}`);

  //   if (Number(versaoDatabase) > Number(versaoApp)) {
  //     console.log("Atualizando versão...");

  //     setTimeUpdate(80000); //Seta o valor do timer para 24H
  //     confirmAlert({
  //       message: "Uma nova versão foi detectada, a aplicação será atualizada !",
  //       closeOnClickOutside: false,
  //       buttons: [
  //         {
  //           label: "Ok",
  //           onClick: () => {
  //             if ("caches" in window) {
  //               caches.keys().then((cacheNames) => {
  //                 cacheNames.forEach((cacheName) => {
  //                   caches.delete(cacheName);
  //                   console.log("Limpeza: " + cacheName);
  //                 });
  //               });
  //             }
  //             setNovaVesao(response.data.Valor);
  //             // window.location.replace(window.location.href);
  //           },
  //         },
  //       ],
  //     });
  //   }
  // }

  async function appVersao() {
    const response = await api.get("/getversao");
    var versaoDatabase = response.data.Valor;
    versaoDatabase = versaoDatabase.replace(/[^0-9]/g, "").trim();
    var versaoApp = process.env.REACT_APP_VERSION;
    const versaoAtual = versaoApp.replace(/[^0-9]/g, "").trim();

    console.log(`versao databse ${versaoDatabase}`);
    console.log(`versao app ${versaoAtual}`);

    if (Number(versaoDatabase) > Number(versaoAtual)) {
      console.log("Nova versão...");
      setAtualizarVersao(true);
      setTimeUpdate(360000); //Seta o valor do timer para 24H
    }
  }

  useEffect(() => {
    appVersao();

    const interval = setInterval(() => {
      appVersao();
    }, timerUpdate);

    return () => clearInterval(interval);
  }, [timerUpdate]);

  // Login
  async function signIn(props) {
    try {
      setErro(false);
      const dataUser = {
        nome_usuario: props.login,
        senha_usuario: props.password,
      };
      const response = await api.post("/session", dataUser);

      if (response.data.error === 1) {
        setErro(true);
        toast.error(response.data.msgError);
        return;
      }

      if (response.data.error === 0) {
        login(response.data?.token);
        setIdTipoUsuario(response.data.user?.id_tipo_usuario);
        setAppNome(response.data.user?.app_nome_fantasia);
        setIdPreposto(response.data.user?.id_preposto);
        setAppLogo(response.data.user?.app_url_logo_principal);
        setIdEmiteMtr(response.data.user?.id_emite_mtr);
        setIdTipoContrapartida(response.data.user?.id_tipo_contrapartida);
        setIdLocal(response.data.user?.id_local);
        setIdDepartamento(response.data.user?.IdDepartamento);
        localStorage.setItem(
          "fullscreen",
          JSON.stringify(response.data.user?.fullScreen)
        );

        const dataUser = jwt.sign(
          {
            appNome: response.data.user?.app_nome_fantasia,
            appLogo: response.data.user?.app_url_logo_principal,
            idEmiteMtr: response.data.user?.id_emite_mtr,
            id_tipo_contrapartida: 1, //response.data.user?.id_tipo_contrapartida
          },
          "DataUser"
        );
        localStorage.setItem("user-data", dataUser);
        Sentry.setUser({
          id: response.data.user?.IDUsuario,
          username: response.data.user?.usuario,
        });

        //console.log(response.data.user)
      }

      if (response.data.user?.AtualizaSenha === 1) {
        setResetSenha(true);
      }

      await getPerfil(response.data.user?.id_tipo_usuario);
      await getOpcoesMenu();
      setErro(false);

      return response;
    } catch (error) {
      setErro(true);
      console.log(error);
      toast.error(
        `Erro ao fazer a requisição, tente novamente. Se persistir entre em contato com o suporte`
      );
      Sentry.captureException(error, {
        extra: {
          response: error.response?.data.message,
          status: error.response?.status,
          url: "/session",
        },
      });
      // if (error.response.status === 500) {
      //   toast.error("Um erro de servidor ocorreu, entre em contato com o suporte");
      // }
      // if (error.request) {
      //   toast.error(`Nenhuma resposta recebida: ${error}`);
      // }
    }
  }

  function logout() {
    exit();
    Sentry.setUser(null);
    localStorage.removeItem("menu");
    localStorage.removeItem("fullscreen");
    setIdTipoUsuario(null);
  }

  return (
    <AuthContext.Provider
      value={{
        logout,
        signIn,
        idTipoUsuario,
        nome_usuario,
        versaoApp,
        setVersaoApp,
        appLogo,
        appNome,
        preposto,
        link_whatsapp,
        idEmiteMtr,
        idTipoContrapartida,
        idLocal,
        idPreposto,
        idDepartamento,
        idTipoMenu,
        erro,
        resetSenha,
        setResetSenha,
        atualizarVersao,
        setAtualizarVersao,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
